import {
  BANNER_DATA,
  FEATURES,
  SECTION1,
  SECTION2,
  SECTION3,
  SECTION4,
  SECTION5,
  SECTION6,
  TIP,
} from '../../utils/const/products/sound-martix-v10';
import FullPageBanner, {
  ButtonGroup,
} from '../../components/commonComponents/fullPageBanner';
import FullPageFeature from '../../components/productPageComponents/fullPageFeature';
import PageSection from '@/components/productPageComponents/pageSection';
import FullPageVideoSection from '@/components/productPageComponents/fullPageVideoSection';
import BottomTip from '../../components/commonComponents/bottomTip';
import { useUserAgentInfo } from '@/context/user-agent';

/**
 *
 * @description SoundMatrix V10 硬件产品详情页
 */

const SoundMatrix = () => {
  const { isMobile } = useUserAgentInfo();

  return (
    <div>
      <FullPageBanner data={BANNER_DATA} />
      <FullPageFeature data={FEATURES} />
      <FullPageVideoSection
        data={SECTION1}
        position="left"
        mobilePosition="center"
        color="#000"
        scale={1.1}
        type="video"
      />
      <FullPageVideoSection
        data={SECTION2}
        position="right"
        mobilePosition="center"
        color="#000"
        background="#F8F9FA"
        scale={1.1}
        type="image"
      />
      <FullPageVideoSection
        data={SECTION3}
        position="left"
        mobilePosition="center"
        color="#000"
        background="#fff"
        scale={1.1}
        type="video"
      />
      <FullPageVideoSection
        data={SECTION4}
        position="right"
        mobilePosition="center"
        color="#000"
        background="#F8F9FA"
        scale={1.1}
        type="image"
      />
      <FullPageVideoSection
        data={SECTION5}
        position="left"
        mobilePosition="center"
        color="#000"
        background="#fff"
        scale={1.1}
        type="video"
      />
      <PageSection
        data={SECTION6}
        mobilePosition="center"
        width={428}
        height={333}
        mobileWidth={365}
        mobileHeight={226}
        backgroundColor={'#F8F9FA'}
        linkUrl="/product/sound-matrix"
      />
      {isMobile && (
        <ButtonGroup
          data={{
            buttonText: BANNER_DATA.buttonText,
            linkText: BANNER_DATA.linkText,
            businessLink: BANNER_DATA.businessLink,
            experienceLink: BANNER_DATA.experienceLink,
          }}
        />
      )}
      <BottomTip config={TIP} />
    </div>
  );
};

export default SoundMatrix;
